import type { Account, ApiError, ErrorCode } from "@fusion-cloud/api";
import { accessToken } from "./auth";

export class ApiRequestError extends Error {
  constructor(
    readonly status: number,
    readonly code: ErrorCode | "network",
    message: string,
  ) {
    super(message);
    this.name = "ApiRequestError";
  }
}

async function get<T>(path: string): Promise<T> {
  const token = await accessToken();
  let response: Response;
  try {
    response = await fetch(path, { headers: token ? { authorization: `Bearer ${token}` } : {} });
  } catch {
    throw new ApiRequestError(0, "network", "Fusion Cloud could not be reached. Check your connection and try again.");
  }
  const body: unknown = await response.json().catch(() => undefined);
  if (!response.ok) {
    const error = (body as ApiError | undefined)?.error;
    throw new ApiRequestError(response.status, error?.code ?? "internal", error?.message ?? `HTTP ${response.status}`);
  }
  return body as T;
}

export const api = {
  getAccount: () => get<Account>("/v1/account"),
};
